module.exports = __webpack_public_path__ + "d4d2bd8bef38201be830dd8ac0cfdc03.jpg";